export enum CodeVerifyTypeEnum {
  CODE_CALL = 'code-call',
  CODE_CALL_VOICE = 'code-call-voice',
  CODE_TELEGRAM = 'code-telegram',
}

export enum CodeVerifyStatusEnum {
  SEND = 'send',
  USED = 'used',
  BLOCKED = 'blocked'
}
